import React from "react";
import "../styles.css";

type CoachMarkStepEightProps = {
  visible: boolean;
  onNext: () => void;
};

const CoachMarkStepEight = ({ visible, onNext }: CoachMarkStepEightProps) => {
  if (!visible) return null;

  return (
    <div
      className="coachmark-overlay coachmark-overlay-centered"
      role="dialog"
      aria-modal="true"
      aria-label="Coach mark step eight"
    >
      <div className="coachmark-step-eight-card">
        <div className="coachmark-step-eight-inner">
          <img
            src={require("../../assets/u4uOnb.png")}
            alt="U4U"
            className="coachmark-step-eight-logo"
          />
          <img
            src={require("../../assets/ic_housepledge.png")}
            alt="House pledge"
            className="coachmark-step-eight-title"
          />

          <img
            src={require("../../assets/telephone.png")}
            alt="Telephone illustration"
            className="coachmark-step-eight-illustration"
          />

          <div className="coachmark-step-eight-text mt-2">
            I’ll reach out to a trusted adult for help, or call/text 988 if I ever feel distressed or in crisis. 
          </div>

          <button
            type="button"
            onClick={onNext}
            className="coachmark-step-eight-next"
            aria-label="Count me in"
          >
            <span>COUNT ME IN!</span>
            <img
              src={require("../../assets/arrow-left-coach.png")}
              alt=""
              aria-hidden="true"
              className="coachmark-step-eight-next-icon"
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CoachMarkStepEight;